import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBack"><Path fillRule="evenodd" clipRule="evenodd" d="M4 3.99988V19.9999H6V3.99988H4Z" fill="currentColor"/><Path d="M20 3.65723V20.3426L7.1651 11.9999L20 3.65723Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBack;
